import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'contactMatrixCount',
    standalone: false
})
export class ContactMatrixCountPipe implements PipeTransform {
    transform(dataMatrix: { string: { string: number } }, level: string, department: string): number {

        if (level in dataMatrix && department in dataMatrix[level]) {
            return (dataMatrix[level][department]).toLocaleString();
        }
        return 0;

    }
}